import optionsApi from "./optionsApi";

export type BillingOverride = {
  employeeId: string;
  companyId: string;
  billingStartDate: string;
  reason: string;
};

export type BillingReportRequest = {
  financialYear: number;
  quarters?: string[];
  companyIds?: string[];
  statuses?: string[];
  activityStartDate?: string;
  activityEndDate?: string;
  applyGoLiveFloor?: boolean;
  excludeForfeitedFromNetVested?: boolean;
  considerOnlyVestedOptions?: boolean;
  overrides?: BillingOverride[];
};

export type BillingInvoiceSlab = {
  upperLimit: number;
  annualRate: number;
};

export type RenewalBillingFrequency = "YEARLY" | "HALF_YEARLY" | "QUARTERLY";
export type BillingInvoicePricingModel =
  | "CAPACITY_SLABS"
  | "INCLUDED_CAPACITY_OVERAGE";

export type BillingInvoiceRequest = BillingReportRequest & {
  pricingModel: BillingInvoicePricingModel;
  slabs?: BillingInvoiceSlab[];
  includedCapacity?: number;
  includedAnnualRate?: number;
  overageAnnualRate?: number;
  renewalFrequency: RenewalBillingFrequency;
};

export const getBillingReport = (payload: BillingReportRequest) =>
  optionsApi
    .post("v1/billing/report", payload)
    .then((response) => response.data.data);

export const getBillingReportDetails = (
  payload: BillingReportRequest & { companyId: string }
) =>
  optionsApi
    .post("v1/billing/report/details", payload)
    .then((response) => response.data.data);

export const searchBillingCompanies = (search: string) =>
  optionsApi
    .get("v1/billing/companies", { params: { search } })
    .then((response) => response.data.data);

export const uploadBillingCompanies = (file: File) => {
  const data = new FormData();
  data.append("file", file);
  return optionsApi
    .post("v1/billing/companies/upload", data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => response.data.data);
};

export const exportBillingReport = (payload: BillingReportRequest) =>
  optionsApi.post("v1/billing/export", payload, { responseType: "blob" });

export const previewBillingInvoice = (payload: BillingInvoiceRequest) =>
  optionsApi
    .post("v1/billing/invoice/preview", payload)
    .then((response) => response.data.data);

export const exportBillingInvoice = (payload: BillingInvoiceRequest) =>
  optionsApi.post("v1/billing/invoice/export", payload, {
    responseType: "blob",
  });
